/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icon-line': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M827.904 116q16.192 0 30.592 5.856t25.216 16.64T900.8 163.68t6.304 31.488v633.6q0 34.208-22.048 56.704t-55.36 22.496H195.2q-36 0-58.048-23.392t-22.048-58.496V194.272q0-31.488 21.6-54.912t57.6-23.392h633.6zm-208.8 675.008q16.192 0 23.392-7.648t7.2-20.256q0-11.712-7.2-19.808t-23.392-8.096h-54.912q.896-1.792.896-5.408v-446.4h55.808q16.192 0 22.496-8.096t6.304-19.808-6.304-19.808-22.496-8.096H401.28q-16.192 0-22.496 8.096t-6.304 19.808 6.304 19.808 22.496 8.096h50.4v446.4q0 1.792.448 2.688t.448 2.688h-49.504q-16.192 0-23.392 8.096t-7.2 19.808q0 12.608 7.2 20.256t23.392 7.648h216z"/>'
  }
})
